import React from "react";
import { PARTNERS } from "../data/catalog";

export const PartnersMarquee = () => {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section data-testid="partners-marquee" className="border-y border-leduro-border bg-white py-6 overflow-hidden">
      <div className="leduro-container flex items-center gap-8">
        <span className="shrink-0 leduro-eyebrow whitespace-nowrap">— Trade partners</span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max gap-12 animate-marquee">
            {items.map((p, i) => (
              <span
                key={i}
                className="font-heading font-black tracking-tighter text-leduro-navy/30 text-2xl lg:text-3xl whitespace-nowrap"
              >
                {p}
                <span className="text-leduro-orange/40">.</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersMarquee;
